import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Logo } from '../Logo';
const PROGRESSION = ['DERMX Session', 'Chaptered Snak', 'Evergreen Library'];
interface SlideProps {
  index: number;
  total: number;
}
export function Slide01Title({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-black" data-id="element-33" data-mp="1520ee4h39zfn">
      {/* Hero image with cinematic overlay */}
      <div className="absolute inset-0" data-id="element-34" data-mp="ralsnpvsrk4w">
        <motion.img src="https://cdn.magicpatterns.com/patterns/generated-images/b434e94b-9025-41ca-9786-1db191d3546e.jpg" alt="Dermatologist in a clinical setting" className="w-full h-full object-cover" initial={{
        scale: 1.08
      }} animate={{
        scale: 1
      }} transition={{
        duration: 8,
        ease: 'easeOut'
      }} data-id="element-35" data-mp="r8smsct0d3xy" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/30" data-id="element-36" data-mp="cdutnhq1caft" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-black/40" data-id="element-37" data-mp="24hop4aq875sa" />
      </div>

      {/* Thin brand rule top */}
      <motion.div initial={{
      scaleX: 0
    }} animate={{
      scaleX: 1
    }} transition={{
      delay: 0.1,
      duration: 0.8,
      ease: 'easeOut'
    }} className="absolute top-0 left-0 right-0 h-1 bg-[var(--brand-green)] origin-left z-20" data-id="element-38" data-mp="1zlhgubacxi76" />

      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3,
      duration: 0.6
    }} className="absolute top-[clamp(1.5rem,3vw,2.5rem)] right-[clamp(2rem,6vw,6rem)] z-20 rounded-xl bg-white/95 px-4 py-3 shadow-lg" data-id="element-39" data-mp="1gt5hlxf02x19">
        <Logo width={112} height={28} alt="Snakker" data-id="element-40" data-mp="1318rfyww6x7i" />
      </motion.div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center px-[clamp(2rem,6vw,6rem)] pb-[clamp(5rem,9vh,7rem)] pt-[clamp(2rem,4vw,4rem)]" data-id="element-41" data-mp="y2fblzu4uu46">
        <div className="max-w-5xl" data-id="element-42" data-mp="1nq1laezwbcka">
          {/* Eyebrow */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.25,
          duration: 0.6
        }} className="flex items-center gap-4 mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-43" data-mp="1rrmrxilu6um1">
            <span className="h-px w-10 bg-[var(--brand-green-lighter)]" data-id="element-44" data-mp="18takc1akpssk" />
            <p className="text-[var(--brand-green-lighter)] text-[clamp(0.85rem,1.3vw,1.1rem)] font-semibold uppercase tracking-[0.25em]" data-id="element-45" data-mp="18vd6ubcip3sj">
              DERMX&nbsp;&nbsp;|&nbsp;&nbsp;LEO Pharma Medical
            </p>
          </motion.div>

          {/* Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.7
        }} className="text-white font-bold text-[clamp(2.75rem,6.5vw,6rem)] leading-[0.98] tracking-tight mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-46" data-mp="2p6h97z3fg6rv">
            Evergreen Snak
            <br data-id="element-47" data-mp="3unc4byqnvk6" />
            Content{' '}
            <span className="text-[var(--brand-green-lighter)]" data-id="element-48" data-mp="3tlyq0u92wza">
              — Estimate
            </span>
          </motion.h1>

          {/* Subline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55,
          duration: 0.6
        }} className="text-white/85 text-[clamp(1.1rem,1.7vw,1.5rem)] font-medium max-w-2xl leading-snug mb-[clamp(1.75rem,3vw,2.5rem)]" data-id="element-49" data-mp="3qzcz4jfhabzq">
            A high-level cost estimate to turn the DERMX November 2026 Chronic
            Hand Eczema webinar into interactive, on-demand Snak content for
            LEO Pharma Medical teams.
          </motion.p>

          {/* Progression chip */}
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.75,
          duration: 0.55
        }} className="inline-flex flex-wrap items-center gap-x-3 gap-y-2 bg-white/[0.07] backdrop-blur-md border border-white/15 rounded-full px-[clamp(1rem,2vw,1.75rem)] py-[clamp(0.65rem,1.2vw,1rem)]" data-id="element-50" data-mp="1dc2jykxfr36j">
            {PROGRESSION.map((step, i) => <Fragment key={step} data-id="element-51" data-mp="zlfiwm47d17a" data-mpi={i}>
                <span className="text-white font-semibold text-[clamp(0.8rem,1.2vw,1.05rem)]" data-id="element-52" data-mp="zib7p4sbl574">
                  {step}
                </span>
                {i < PROGRESSION.length - 1 && <span className="text-[var(--brand-green-lighter)] text-lg leading-none" data-id="element-53" data-mp="poaxioi6l9rj">
                    →
                  </span>}
              </Fragment>)}
          </motion.div>
        </div>
      </div>

      {/* Bottom statement */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 0.6
    }} className="absolute bottom-[clamp(1.5rem,3vh,2.5rem)] left-[clamp(2rem,6vw,6rem)] right-[clamp(2rem,6vw,6rem)] z-10 hidden md:block" data-id="element-54" data-mp="g0fd2jiv6vnf">
        <p className="text-white/70 text-[clamp(0.95rem,1.4vw,1.2rem)] font-medium border-l-2 border-[var(--brand-green)] pl-4 max-w-xl" data-id="element-55" data-mp="yp3uuwm1wkuz">
          Lean scope. Transparent cost. Built for Medical team use.
        </p>
      </motion.div>
    </div>;
}